import React, { useEffect } from 'react';

/**
 * Custom hook that listens for clicks or touches outside of a specified reference.
 *
 * @param ref A mutable reference to an HTML element or component
 * @param handler A callback function that will be invoked when a click or touch occurs outside of the reference
 */
const useOnClickOutside = (
  ref: React.MutableRefObject<any>,
  handler: (value: boolean) => void,
) => {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(!!event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export default useOnClickOutside;
